/** Center a row in the visible table body without moving columns or ancestor panes. */
export function centerTableRow(table: HTMLElement, row: HTMLElement, header?: HTMLElement | null): void {
	if (table.clientHeight === 0) {
		return;
	}
	const viewportTop = table.getBoundingClientRect().top + table.clientTop;
	const headerHeight = Math.min(table.clientHeight, Math.max(0, (header?.getBoundingClientRect().bottom ?? viewportTop) - viewportTop));
	const visibleCenter = viewportTop + headerHeight + (table.clientHeight - headerHeight) / 2;
	const rowBounds = row.getBoundingClientRect();
	const desiredTop = table.scrollTop + rowBounds.top + rowBounds.height / 2 - visibleCenter;
	const maximumTop = Math.max(0, table.scrollHeight - table.clientHeight);
	const scrollTop = Math.max(0, Math.min(maximumTop, desiredTop));

	if (Math.abs(table.scrollTop - scrollTop) > 0.5) {
		table.scrollTop = scrollTop;
	}
}
